<h1 mat-dialog-title class="aza-pa-dialog-title aza-cmp-flex-row" >
    <span class="aza-cmp-flex-item-grow" translate>SELECT_AN_EVENT_PRESET</span>
    <azavista-advanced-search
        [showFilters]="false"
        (changed)="onSearchTextChanges($event.quickSearchText)"
        class="aza-cmp-half-padding-block"
    ></azavista-advanced-search>
    <mat-button-toggle-group>
        <mat-button-toggle *ngIf="'list' as value" (change)="listMode = $any(value)" [checked]="value === listMode" [value]="value">
            <mat-icon>format_list_bulleted</mat-icon>
        </mat-button-toggle>
        <mat-button-toggle *ngIf="'grid' as value" (change)="listMode = $any(value)"  [checked]="value === listMode" [value]="value">
            <mat-icon>grid_view</mat-icon>
        </mat-button-toggle>
    </mat-button-toggle-group>
</h1>

<div mat-dialog-content class="aza-pa-dialog-content">
    <p class="empty-text aza-cmp-hidden">{{'ITEM_NOT_FOUND' | translate}}</p>
    <div
        class="aza-pa-padding event-preset-options-container aza-cmp-flex-wrap"
        [class.aza-cmp-grid]="listMode === 'grid'"
        [class.aza-pa-flex-column]="listMode === 'list'"
        [class.aza-cmp-no-gap]="listMode === 'list'"
    >
        <ng-container *ngFor="let item of allEventPresets">
            <ng-container *ngIf="(item.label | translate) as label">
                <ng-container *ngIf="searchText | apply : isContainSearchText: label">
                    <div
                        *ngIf="listMode === 'grid'"
                        (click)="close(item)"
                        class="aza-pa-flex-column aza-pa-flex-item-align-center aza-pa-padding event-preset-container mat-elevation-z1"
                    >
                        <img *ngIf="item.imageSrc" src="{{item.imageSrc}}" width="64" height="45" class="event-preset-image" />
                        <svg *ngIf="item.svgContent"
                            [innerHTML]="item.svgContent | apply : bypassSecurityTrustHtml"
                            xmlns="http://www.w3.org/2000/svg"
                            height="48" viewBox="0 -960 960 960" width="48" class="event-preset-image svg"
                        ></svg>
                        <span class="aza-txt-centered">{{label}}</span>
                    </div>
                    <div
                        *ngIf="listMode === 'list'"
                        (click)="close(item)"
                        class="aza-cmp-padding-block aza-cmp-cursor-hand event-preset-list-item-container"
                    >{{label}}</div>
                </ng-container>
            </ng-container>
        </ng-container>
    </div>
</div>

<div mat-dialog-actions>
    <azavista-flat-button [matDialogClose]="undefined">{{'CANCEL' | translate}}</azavista-flat-button>
</div>
